export default "__VITE_ASSET__BtmHb$xk__"